angular.module('elfium').service('dashboardSumService', ['$q', 'businessCaseService',
    function ($q, businessCaseService) {
        var that = this;
        that.getBusinessCaseSums = function (dashboardFilter) {
            var deferred = $q.defer();
            businessCaseService.getBusinessCases().then(function (businessCases) {
                deferred.resolve(that._buildCounter(businessCases));
            }, deferred.reject);
            return deferred.promise;
        };
        
        that._buildCounter = function (businessCases) {
            return that._fillCounter(businessCases, {
                closed: {},
                toClose: {},
                offers: {}
            });
        };
        that._fillCounter = function (businessCases, counter) {
            angular.forEach(businessCases, function (businessCase) {
                counter.closed.currentSum = businessCase.castka;
                counter.toClose.currentSum = businessCase.castka;
                counter.offers.currentSum = businessCase.castka;
            });
            return counter;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardSumService.ts